<template>
  <div>
    <div :style="gridStyles" data-locator="access-rights-group-row">
      <div class="AccessRightsTable-gridCell sticky-left body-md-bold d-flex align-center column-gap-1"
           style="align-self: center"
      >
        <app-button
          type="icon"
          @click="$emit('toggleGroup', group.id)"
        >
          <app-material-icon name="chevron_right"
                             color="icon-secondary"
                             size="xs"
                             class="AccessRightsTable-groupChevron"
                             :class="{'AccessRightsTable-groupChevron--open': isOpen}"
          />
        </app-button>
        <AppTooltip>
          <template #activator="{ props }">
            <div class="text-truncated text-text-secondary"
                 v-bind="props"
            >
              {{ group.name }}
            </div>
          </template>
          <span>{{ group.name }}</span>
        </AppTooltip>
      </div>
      <div v-for="column in displayedColumns"
           :key="`group-${group.id}-column-${column.propertyName}`"
           class="AccessRightsTable-gridCell"
      >
        <v-checkbox :model-value="group[column.propertyName]"
                    :indeterminate="isGroupPartiallyChecked(column.propertyName)"
                    :disabled="isCheckboxDisabled(column)"
                    density="compact"
                    hide-details
                    class="AccessRightsTable-checkbox"
                    :data-locator="rightToLocatorValue(column.propertyName)"
                    @update:model-value="patchGroupRights(column.propertyName, $event)"
        />
      </div>
    </div>
    <template v-if="isOpen">
      <AccessRightsMember v-for="member in group.members"
                          :key="`group-${group.id}-member-${member.id}`"
                          :grid-styles="gridStyles"
                          :patch-rights-pending="patchRightsPending"
                          :member="member"
                          :is-group-pm="Boolean(group.isPm)"
                          :displayed-columns="displayedColumns"
                          @patchRoomRightsSuccess="$emit('patchRoomRightsSuccess')"
                          @patchRoomRightsError="$emit('patchRoomRightsError')"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { toKebabCase } from '@/common/utils/strings'
import { PATCH_ROOM_GROUP_RIGHTS } from '@/store/modules/room/action_types'

import AccessRightsMember from './AccessRightsMember.vue'

export default {
  name: 'AccessRightsGroup',
  components: {
    AppTooltip,
    AccessRightsMember,
  },
  props: {
    gridStyles: {
      type: Object,
      required: true,
    },
    patchRightsPending: {
      type: Boolean,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    displayedColumns: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['isDataRoom', 'roomMnemo']),
  },
  methods: {
    ...mapActions('room', [PATCH_ROOM_GROUP_RIGHTS]),
    isGroupPartiallyChecked (property) {
      return !this.group[property] && (this.group.members.length > 0 && this.group.members.some(g => g[property]))
    },
    async patchGroupRights (property, value) {
      try {
        await this.PATCH_ROOM_GROUP_RIGHTS({
          mnemo: this.roomMnemo,
          groupId: this.group.id,
          data: {
            [property]: value,
          },
        })
        this.$emit('patchRoomRightsSuccess')
      } catch (error) {
        this.$emit('patchRoomRightsError')
      }
    },
    isCheckboxDisabled (column) {
      if (column.disableCheck?.group) {
        return column.disableCheck.group(this.group)
      }

      return Boolean(this.group.isPm) || this.patchRightsPending
    },
    rightToLocatorValue (property) {
      return toKebabCase(property) + '-checkbox'
    },
  },
}
</script>
